import React from 'react';
import logo from '../assets/images/spanner.png'; // Import your image here

// Keyframes for the floating animation
const keyframes = `
  @keyframes float {
    0% {
      transform: translateY(0px);
    }
    50% {
      transform: translateY(-10px);
    }
    100% {
      transform: translateY(0px);
    }
  }
`;

const styles = {
  // --- Main Container ---
  bg: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    background: 'linear-gradient(135deg, #f5f7fa 0%, #FFFF8F 100%)', // Modern gradient background
    padding: '20px',
    fontFamily: "'Inter', sans-serif", // A modern font choice (add to your project/index.html)
    boxSizing: 'border-box',
  },
  // --- Content Card ---
  card: {
    backgroundColor: 'white',
    maxWidth: '550px',
    width: '100%',
    padding: '50px 40px',
    borderRadius: '16px', // Softer corners
    textAlign: 'center',
    boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)', // Softer, more pronounced shadow
    border: '1px solid #e2e8f0',
  },
  // --- Icon ---
  maintenanceIcon: {
    width: '120px', // A bit larger for more impact
    marginBottom: '30px',
    animation: 'float 3s ease-in-out infinite', // Add subtle animation
    justifyContent: 'center',
    display: 'flex',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  // --- Typography ---
  h1: {
    color: '#1a202c', // Darker, more modern text color
    fontSize: '2rem', // Larger font size
    fontWeight: '700', // Bolder
    marginBottom: '15px',
    letterSpacing: '-0.5px',
  },
  h2: {
    color: '#4a5568', // Softer secondary text color
    fontSize: '1rem',
    fontWeight: '400',
    lineHeight: '1.6', // Improved readability
    maxWidth: '450px',
    margin: '0 auto', // Center the text block if it wraps
  },
  // --- Optional Button Style (if you uncomment it) ---
  button: {
    marginTop: '40px',
    padding: '12px 30px',
    fontSize: '14px',
    fontWeight: '600',
    backgroundColor: '#3182ce', // A modern blue
    color: 'white',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    transition: 'background-color 0.3s ease, transform 0.2s ease',
  },
  buttonLink: {
    textDecoration: 'none',
    color: 'inherit', // Inherit color from the button
  },
};

function Maintenance() {
  return (
    <>
      {/* Injecting keyframes animation into the document head */}
      <style>{keyframes}</style>

      <div style={styles.bg}>
        <div style={styles.card}>
          <img
            src={logo}
            alt="Under Maintenance"
            style={styles.maintenanceIcon}
          />

          <h1 style={styles.h1}>Maintenance Mode</h1>

          <h2 style={styles.h2}>
            Our website is currently undergoing maintenance.
            <br />
            We apologize for the inconvenience and please try again later.
          </h2>

          {/* Uncomment the button if you need it. It's now styled to match! */}
          {/*
          <div>
            <button
              style={styles.button}
              onMouseOver={(e) => e.currentTarget.style.backgroundColor = '#2b6cb0'}
              onMouseOut={(e) => e.currentTarget.style.backgroundColor = '#3182ce'}
            >
              <a
                href="https://payment.inet.co.th"
                target="_blank"
                rel="noopener noreferrer"
                style={styles.buttonLink}
              >
                กลับสู่หน้าชำระเงิน INET
              </a>
            </button>
          </div>
          */}
        </div>
      </div>
    </>
  );
}

export default Maintenance;
